import store from '@/store'

export default function settingsModule() {
  const isSettingsEmpty = () => {
    const settings = store.state.app.settings
    if (!settings) return true
    return Array.isArray(settings) ? settings.length === 0 : Object.keys(settings).length === 0
  }

  const setSettingsToStore = () => {
    if (!isSettingsEmpty()) return Promise.resolve(store.state.app.settings)

    return store.dispatch('api/fetchSettings').catch(() => null)
  }
  const setWidgetSettingsToStore = () => {
    // Displayed points and beneficiary
    if (isSettingsEmpty()) {
      store
        .dispatch('widget/fetchSettings')
        .then(response => response.data)
        .then(response => {
          store.commit('app/SET_SETTINGS', response.data)
        })
        .catch(() => null)
    }
  }
  const setSettings = app => {
    app.updateDisplayedPoints(store.state.app.settings.display_loyalty_system_points)
    app.updateDisplayedBeneficiary(store.state.app.settings.display_loyalty_system_beneficiary)
    app.updateUseOldTicketGenerationType(store.state.app.settings.use_old_ticket_generation_type)
  }
  const setWidgetSettings = app => {
    app.updateDisplayedPoints(store.state.app.settings.display_loyalty_system_points)
    app.updateDisplayedBeneficiary(store.state.app.settings.display_loyalty_system_beneficiary)
    app.updateUseOldTicketGenerationType(store.state.app.settings.use_old_ticket_generation_type)
  }
  return {
    setSettingsToStore,
    setWidgetSettingsToStore,
    setSettings,
    setWidgetSettings,
  }
}
